// In reservasMenuReducer.ts or a new reducer
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { MenuReserva } from '@/core/odata/interfaces/MtPerseveranceBackendApiRepositoriesModel'

interface MenuReservaState {
  menuReservas: MenuReserva[]
  isMapi: boolean
  isBoletos: boolean
  isTrenesPE: boolean
}

const initialState: MenuReservaState = {
  menuReservas: [],
  isMapi: false,
  isBoletos: false,
  isTrenesPE: false,
}

const menuReservaSlice = createSlice({
  name: 'menuReserva',
  initialState,
  reducers: {
    setMenuReservas: (state, action: PayloadAction<MenuReserva[]>) => {
      state.menuReservas = action.payload
    },
    setIsMapi: (state, action: PayloadAction<boolean>) => {
      state.isMapi = action.payload
    },
    setIsBoletos: (state, action: PayloadAction<boolean>) => {
      state.isBoletos = action.payload
    },
    setIsTrenesPE: (state, action: PayloadAction<boolean>) => {
      state.isTrenesPE = action.payload
    },
  },
})

export const { setMenuReservas, setIsMapi, setIsBoletos, setIsTrenesPE } =
  menuReservaSlice.actions

const ReservasMenuReducer = menuReservaSlice.reducer

export default ReservasMenuReducer
